<template>
  <section class="config-message-index-container">
    <base-header
      v-if="$env === 'dev'"
      v-bind="headers"
      @handleLink="handleHeaderLink"
      />
    <base-table
      v-bind="list"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </base-table>
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseTable from '@/components/mixins/baseTable'
const columns = [
  {
    prop: 'id',
    label: '序号',
    width: '65px'
  },
  {
    prop: 'mesTitle',
    label: '模板名称',
    scopeType: 'link',
    href: '/config/information/detail',
    params: {
      status: 'member'
    }
    // width: '325px'
  },

  {
    prop: 'mesCode',
    label: '模板标识'
  },
  {
    prop: 'remark',
    label: '模板描述',
    showOverflowTooltip: true
  }
]
export default {
  name: 'membership',
  mixins: [baseHeader, baseTable],
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      headers: {
        buttons: [
          {
            type: 'Link',
            text: '新建',
            icon: 'xinjian',
            href: '/config/information/detail',
            params: {
              type: 'add',
              status: 'member'
            },
            disabled: !this._checkPermission('/admin/messageTpl', 'POST')
          }
        ],
        title: '',
        showAlertIcon: false,
        content: '操作说明'
      },
      list: {
        columns,
        api: 'fetchMessageTplPage',
        params: {
          tplType: 1
        }
      }
    }
  },
  methods: {
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.$set(this.list, 'data', res.data.content)
        this.list.totalCount = res.data.totalElements
      }
    },
    getParams (type) {
      this.list.columns.find(v => v.prop === 'mesTitle').params.status = parseInt(type) === 1 ? 'member' : 'user'
      this.headers.buttons[0].params.status = parseInt(type) === 1 ? 'member' : 'user'
      this.list.params.tplType = parseInt(type)
      this.fetchTableApi()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchTableApi()
    })
  },
  watch: {
    name (newVal, oldVal) {
      if (newVal) {
        this.getParams(newVal)
      }
    }
  },
  activated () {
    if (this.$route.query.type === 'list') {
      this.fetchTableApi()
      this.$router.push({ query: { type: '' } })
    }
  }
}
</script>

<style lang="scss" scoped></style>
